import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@EspaceParkQC/sdk-react";
import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";

interface WelcomeModalProps {
  open: boolean;
  onDismiss: () => void;
}

export default function WelcomeModal({ open, onDismiss }: WelcomeModalProps): React.ReactElement {
  const { t } = useTranslation("modals");
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onDismiss()}>
      <DialogContent className="sm:max-w-md flex flex-col justify-center h-full sm:h-auto sm:max-h-[320px]">
        <DialogHeader className="flex flex-col items-center text-center space-y-4">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
            <Bell className="size-8 text-primary" fill="currentColor" stroke="transparent" />
          </div>
          <DialogTitle>{t("welcome.title")}</DialogTitle>
          <DialogDescription>{t("welcome.description")}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onDismiss} className="w-full">
            {t("welcome.continue")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
